import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const deliveryPartnerList = createAsyncThunk('deliveryPartner/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `delivery_partner`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const deliveryPartnerDetails = createAsyncThunk('deliveryPartner/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `delivery_partner/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addDeliveryPartner = createAsyncThunk('deliveryPartner/add', async (data) => {

    var bodyFormData = new FormData();
    bodyFormData.append('dp_name', data?.values?.name);
    bodyFormData.append('dp_type', data?.values?.type);
    bodyFormData.append('status', data?.values?.status);
    if (data?.values?.logo) {
        bodyFormData.append('dp_logo', data?.values?.logo);
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'delivery_partner',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "dp_logo", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateDeliveryPartner = createAsyncThunk('deliveryPartner/update', async (data) => {

    var bodyFormData = new FormData();
    bodyFormData.append('dp_id', data?.values?.id);
    bodyFormData.append('dp_name', data?.values?.name);
    bodyFormData.append('dp_type', data?.values?.type);
    bodyFormData.append('status', data?.values?.status);
    if (data?.values?.logo && typeof data?.values?.logo !== 'string') {
        bodyFormData.append('dp_logo', data?.values?.logo);
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_delivery_partner',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "dp_logo", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delDeliveryPartner = createAsyncThunk('deliveryPartner/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `delivery_partner/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const deliveryPartner = createSlice({
    name: 'deliveryPartner',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(deliveryPartnerList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(deliveryPartnerDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default deliveryPartner.reducer;